var React = require('react');

function GreenRightArrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#12DFC7","strokeWidth":"2","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},[React.createElement("path",{"d":"m10.225 16.904 4.8-4.58-4.8-4.828","key":0}),React.createElement("path",{"d":"M22 12c0 5.515-4.468 10-10.012 10C6.468 22 2 17.515 2 12S6.467 2 11.988 2C17.532 2 22 6.485 22 12z","key":1})]));
}

GreenRightArrow.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = GreenRightArrow;

GreenRightArrow.default = GreenRightArrow;
